import { _ } from "../utils/helpers"
import { booking, ROUTES, SCREEN_BREAKPOINT_1 } from "../utils/symbols"
import { ShiftSelectionWithTables } from "./ShiftSelectionWithTables"
import { Icon } from "../parts/Icon"
import { useApp } from "../context/useApp"

export const ShiftSelectionWithoutTables = () => {

    const {
        state: { screen },
        actions: { navigate }
    } = useApp()

    return booking.step === "shift" ? (
        <div className="w-100 mb-8 mr-13">
            { screen.width >= SCREEN_BREAKPOINT_1 && (
                <button 
                    type="button"
                    className="button b-0 p-0 df aic mb-7" 
                    onClick={() => {
                    booking.setBookingStep("date").render()
                    navigate(ROUTES.DATE)

                }}
            >
                <Icon icon={'arrow'} className="rt180 mr-5"/>
                <p className="text s18-600">{_('0ge_gobac__')}</p>
            </button>
)}
            <h1 className="text s24-600 mb-10">{_("0ab_whatt__")}</h1>
            <ShiftSelectionWithTables />
        </div>
    ) : null
}